/**
 * Central Feature Flags & Toggle System
 * Change any flag from false to true (or vice-versa) to instantly show/hide elements.
 */
export const FEATURES = {
  // Pages & Navigation
  showJourneyPage: false,        // The dedicated /journey page, header nav link, and footer link

  // Homepage Sections
  showFoundationDonation: false, // The sacred quote & donation button on homepage

  // Atmosphere / Landscape Lights
  showBlinkingStars: false,      // 45 twinkling CSS stars overlay in sky
  showFireflies: false,          // 20 floating blinking fireflies
  showCampfireFlames: false,     // Flickering flame tips & pulse glow over campfire

  // Team Sections
  showTikkaramVision: false,     // "His Vision" section under Tikkaram's profile
};
